export default __webpack_public_path__ + "8f844cb32039d811f716c376828baeff.png";